// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"caret-right"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16.5 12L9.5 5L9.5 19L16.5 12Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16.5 12L9.5 5L9.5 19L16.5 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CaretRightIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'caret-right',
    ref,
    icon: element,
  },
));

CaretRightIcon.displayName = 'CaretRightIcon';

export default CaretRightIcon;
